__turbopack_context__.v({
  "disabledItem": "CreationButton-module__6lISjW__disabledItem",
  "divider": "CreationButton-module__6lISjW__divider",
  "iconButtonWrapper": "CreationButton-module__6lISjW__iconButtonWrapper",
  "menu": "CreationButton-module__6lISjW__menu",
  "menuText": "CreationButton-module__6lISjW__menuText",
  "regularButtonWrapper": "CreationButton-module__6lISjW__regularButtonWrapper",
  "root": "CreationButton-module__6lISjW__root",
});
